export default "__VITE_ASSET__KwR76jl9__"